<template>
    <section class="nti-webshop-checkout__complete-purchase">
        <div class="nti-webshop-checkout__agreement-container">
            <label for="accept-conditions" class="custom-control custom-checkbox nti-webshop-checkout__agreement-wrapper">
                <input v-model="form.conditions" type="checkbox" id="accept-conditions" class="form-control custom-control-input" data-js="accept-conditions" required>
                <span class="custom-control-indicator" :class="invalidCheckbox"></span>
                <span class="nti-webshop-checkout__agreement-label">
                    {{ verifyLabel("termsText") }}
                    <a class="nti-link" target="_blank" :href="termsUrl">{{ verifyLabel("termsLinkText") }}</a>
                </span>
            </label>

            <label for="accept-newsletter" class="custom-control custom-checkbox">
                <input v-model="form.newsletter" type="checkbox" id="accept-newsletter" class="form-control custom-control-input">
                <span class="custom-control-indicator"></span>
                <span class="nti-webshop-checkout__agreement-label">
                    {{ verifyLabel("subScribeNewsletter") }}
                    <a class="nti-link" target="_blank" :href="privacyUrl">{{ verifyLabel("privacyLinkText") }}</a>
                </span>
            </label>
        </div>
        <button @click.prevent="submitNow(readytosubmit)" class="nti-button nti-button--confirm pardotTrackClick" :class="submitButton" aria-label="Complete your purchase">
            {{ verifyLabel("submitOrderButton") }}
            <div class="nti-svg__container-small nti-svg--go-to-checkout">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
                </svg>
            </div>
        </button>

        <article class="nti-webshop-checkout__discount-container">
            <label for="coupon-discount-input"><strong>{{ verifyLabel("promotionCodeLabel") }}</strong></label>
            <div class="nti-webshop-checkout__discount-container__input">
                <input form="checkoutform" @keyup="discountInputInteraction" @keydown.enter.prevent="applyCouponCode" id="coupon-discount-input" class="nti-webshop-checkout__discount-input" type="text" name="DiscountCode" data-coupon-code="" :value="initialDiscountCode" data-js="discount-button">
                <button
                    @click.prevent="applyCouponCode"
                    id="coupon-discount-button"
                    class="nti-webshop-checkout__discount-apply-button nti-button nti-button--discount-voucher js-discount-button"
                    type="button"
                    data-js="apply-coupon-code">{{ verifyLabel("promotionCodeApplyLabel") }}</button>
            </div>
            <span class="nti-webshop-checkout__discount-container__label">{{ couponNotValidMessage }}</span>
        </article>
    </section>
</template>

<script>
import store from 'store'
import verifyLabel from '../../../methods/verifyLabel'

export default {
    props: {
        labels: Object,
        termsUrl: String,
        privacyUrl: String,
        initialDiscountCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form: {
                conditions: false,
                newsletter: false
            }
        }
    },
    computed: {
        attemptedSubmit() {
            return store.state.cart.attemptedSubmit
        },
        readytosubmit() {
            const formComplete = store.state.cart.formComplete
            const conditionsAccepted = this.form.conditions
            return !!(conditionsAccepted && formComplete)
        },
        submitButton() {
            return !this.readytosubmit ? 'nti-button--not-ready' : ''
        },
        invalidCheckbox() {
            return this.attemptedSubmit && !this.form.conditions ? 'nti-checkbox--invalid' : ''
        },
        couponNotValidMessage() {
            return store.state.cart.couponNotValidMessage
        },
        checkoutLabels() {
            if (store.state.main.labels) {
                return store.state.main.labels
            }
        }
    },
    methods: {
        submitNow() {
            store.commit('cart/attemptSubmit')
            if (this.readytosubmit) {
                document.querySelector('#checkoutform').submit()
                document.querySelector('div.nti-webshop-checkout__overlay').style.visibility = 'visible';
            }
        },
        discountInputInteraction(e) {
            const discountBtn = document.getElementById('coupon-discount-button');
            if (e.target.value != "") {
                if (discountBtn.firstElementChild != null) return;
                const css = "#coupon-discount-button { background-color: #006fb6 } #coupon-discount-button:hover { background-color: #00406a }";
                var style = document.createElement('style');

                if (style.styleSheet) style.styleSheet.cssRules = css;
                else style.appendChild(document.createTextNode(css));

                discountBtn.appendChild(style);
            } else if (discountBtn.firstElementChild) {
                discountBtn.removeChild(discountBtn.firstElementChild);
            }
        },
        applyCouponCode() {
            const inputValue = document.getElementById('coupon-discount-input').value
            store.dispatch("cart/checkCouponCode", inputValue)
        },
        verifyLabel(displayName) {
            if (store.state.main.labels) {
                return verifyLabel(displayName, store.state.main.labels)
            } else {
                return ""
            }
        }
    },
    watch: {
        form: {
            handler() {
                store.dispatch('cart/conditionsAndPermissions', this.form)
            },
            deep: true
        }
    }
}
</script>
